<template>
    <div id="letter" class="letter-inner letter">
        <div class="letter-item" v-show="successYn !== 'Y'">
            <div>
                <input type="text" v-model="email" placeholder="이메일 주소" @click="sendGtag('email')" />
                <button @click="submit()">구독하기</button>
            </div>
            <a @click="sendGtag('prevLetter')" href="https://page.stibee.com/archives/85645" target="_blank">지난호 보기</a>
        </div>
        <div class="letter-item" v-show="successYn === 'Y'">
            <h2>에이아이런 레터</h2>
            <p class="letter-txt" style="">신청해 주셔서 감사합니다.</p>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "letter",
        data() {
            return {
                email: '',
                successYn: 'N',
            };
        },
        created: function() {
        },
        methods: {
            submit(){
                gtag('event', '구독', {
                    'event_category': 'click',
                    'event_label': '구독',
                    'value': '',
                });

                if(this.email === '') {
                    swal("필수 항목 미입력", "이메일 주소를 입력해주세요.", "error" );
                    return false;
                }

                let parameters = {
                    email: this.email,
                };

                axios({
                    method : 'POST',
                    url : 'https:\/\/www.danbee.ai/chatflow/event/v2.0/10b92062-314a-4886-b64b-980fb0a3c228/185bba58-971a-4ea4-a42b-18c180a18820/message.do',
                    headers : {
                        'Content-Type' : 'application/json'
                    },
                    data : JSON.stringify({
                        chatbot_id: '10b92062-314a-4886-b64b-980fb0a3c228',
                        parameters: parameters,
                    })
                }).then((response) => {
                    // console.log('response : ');
                    // console.log(response);
                    // swal("구독 완료", "구독이 완료되었습니다.", "success" );
                    this.successYn = 'Y';
                }).catch((error) => {
                    swal("구독 실패", "오류가 발생했습니다. 관리자에게 문의바랍니다.", "error" );
                });
            },
            resetParameters() {
                this.email = '';
            },
            sendGtag(type) {
                let event_name = '';
                switch (type) {
                    case 'prevLetter':
                        event_name = '지난호 보기';
                        break;
                    case 'email':
                        event_name = '이메일주소 클릭';
                        break;
                }

                gtag('event', event_name, {
                    'event_category': 'click',
                    'event_label': event_name,
                    'value': '',
                });
            },
        },
        beforeDestroy() {
        },
        destroyed () {
        },
        watch: {
        },
        computed: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/letter.vue